import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { bonuses } from '../../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonuses-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-66" data-mp="16m0vlgnh87es">
      <div className="mx-auto max-w-5xl" data-id="element-67" data-mp="1bjiyapawhqec">
        <div className="flex justify-center" data-id="element-68" data-mp="1bi7skjxwa8kl">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-ivory" data-id="element-69" data-mp="wms5iyvqfcxp">
            <GiftIcon className="h-5 w-5 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-70" data-mp="11mehz63qkp5g" />
          </span>
        </div>
        <SectionHeading id="bonuses-heading" eyebrow="You Also Get" title="Plus, Get 5 Additional Teaching Resources!" body="Five coordinated bonuses designed to make your barbering classes even easier to prepare and deliver." className="mt-5" data-id="element-71" data-mp="nnoi5ipj8bde" />

        <ol className="mt-12 grid gap-6 md:grid-cols-2" role="list" data-id="element-72" data-mp="2myz61i4k780s">
          {bonuses.map((bonus, index) => <li key={bonus.number} className={`flex h-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0_24px_50px_-36px_rgba(90,70,40,0.45)] ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-73" data-mp="1k5r46hyw78cc" data-mpi={index}>
              <div className="px-6 py-3" style={{
            backgroundColor: bonus.accent
          }} data-id="element-74" data-mp="1oz3poj89yz0v">
                <p className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/80" data-id="element-75" data-mp="119rbf4y3c0rp">
                  {bonus.number}
                </p>
              </div>
              <div className="flex flex-1 flex-col px-6 py-7 sm:px-8" data-id="element-76" data-mp="1b870z3hgz1z3">
                <h3 className="font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal" data-id="element-77" data-mp="168c8wwlyk6cg">{bonus.title}</h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-78" data-mp="2mlj93qk9i6r2">{bonus.description}</p>
                <p className="mt-auto flex items-center gap-1.5 self-start pt-5 font-body text-[11px] font-bold uppercase tracking-[0.14em] text-brand-cta" data-id="element-79" data-mp="2hm6f8luz3zez">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-80" data-mp="2tpitz43ckqbr" />
                  {bonus.badge}
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-81" data-mp="33ngephm004zm">
          Visuals. Classroom kits. Corrections. Activities. Careers. <Accent data-id="element-82" data-mp="2ayhu8duekqr5">Already done for you.</Accent>
        </p>
      </div>
    </section>;
}